import React from "react";

import { Text, textPropTypes } from "../Text";

/** The Sup component renders superscript text. */
export const Sup = (props) => <Text element="sup" isSuperScript {...props} />;

Sup.displayName = "Sup";

Sup.propTypes = textPropTypes;
